/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedSkeleton.defs'
export { main as default } from './getFeedSkeleton.defs'
